<template>
  <div>
    <table class="table text-sm">
        <thead>
            <tr>
                <th v-for="column in tableDefs.columns" :key="column.key" :class="[{filtered : (column.activeFilter || column.activeSort)},{filterable : (column.sortable || column.filter)}]" :width="column.width" v-show="column.hide == null || column.hide == false" :style="{minWidth: column.minWidth}">
                    <component v-if="handleRendererComponent(column.label)" v-bind:is="column.label" :table-data="tableDataObject" v-dynamic-events="knownEvents"></component>
                    <span v-else v-html="column.label"></span>

                    <div v-if="column.showTooltip" class="tableColumn-tooltip-wrapper">
                      <i class="fa fa-info-circle text-light warning-beepiz-remote-monitoring show" style="font-size: 1rem; margin-left: 10px; cursor:pointer;"></i>
                      <div class="tooltip top" style="width: 250px; right:-5px; top:calc(100% + 0.75rem + 12px)">
                        <h5 style="color:#ffc107; font-weight:700">{{ column.tooltipTitle}}</h5>
                        {{ column.tooltipContent}}
                      </div>
                    </div>

                    <i v-if="column.sortable || column.filter" class="fa fa-arrows-v"  ></i>
                    <i v-if="column.sortable || column.filter" class="fa fa-cog" v-on:click="popupHandler(column)" ></i>

                    <TableFilterPopup v-if="(column.sortable || column.filter) && column.showPopup" :columnData="column" v-on:sort="handleSort" v-on:filter="handleFilter" v-on:close="popupHandler"></TableFilterPopup>
                </th>

                <th v-if="tableDefs.rowActions.actions"></th>
            </tr>
        </thead>
        <draggable :list="tableDataObject" :element="'tbody'" :options="options" v-if="tableDataObject && tableDataObject.length > 0 && !loading" @end="handleEnd">
            <tr v-for="item in tableDataObject">
                <td v-for="column in tableDefs.columns" :key="column.key" :class="[column.className,getSpRowClassname(item)]" :width="column.width" @click="onClickCell(column,item)"  v-show="column.hide == null || column.hide == false">
                    <component v-bind:is="column.renderer" :object="item" :columnKey="column.key"  v-if="handleRendererComponent(column.renderer)" v-dynamic-events="knownEvents"></component>
                    <span v-if="handleRendererFunction(column.renderer)" v-html="column.renderer(item)" :style="column.style"></span>
                    <router-link v-if="column.linkTo && !column.renderer" :to="parseLink(column.linkTo,item)">{{ accessValue(item,column.key) }}</router-link>
                    <span v-if="!column.renderer && !column.linkTo && !displayIcon(item.type, column.key)" :title="createReceiversList(item.receivers, column)">
                        {{ accessValue(item,column.key) }}
                    </span>
                    <i v-if="displayIcon(item.type, column.key)" :class="'fa fa-' + displayIcon(item.type, column.key) + '  fa-fw'"></i>
                </td>
                <td :width="tableDefs.rowActions.width" v-if="tableDefs.rowActions.actions" :class="getSpRowClassname(item)">
                    <span class="actions d-flex">
                        <router-link v-for="action in tableDefs.rowActions.actions" :key="action.label" tag="i" :to="parseLink(action.linkTo,item)" :class="action.class" :title="action.label" @click.native.prevent="onClickAction(action,item)" tabindex="0"></router-link>
                    </span>
                </td>
            </tr>
        </draggable>

      <tbody v-if="!loading && (tableDataObject.length == 0 || !tableDataObject)">
          <tr class="no-content">
              <td v-if="tableDefs.global && tableDefs.global.noItemsMsg" :colspan="nbColumns" v-html="tableDefs.global.noItemsMsg"></td>
          </tr>
      </tbody>
    </table>

    <div v-if="loading" style="display: flex; justify-content: center; width: 100%">
      <div style="display: flex">
        <b-spinner class="mr-auto" style="margin-right: 7px"></b-spinner>
        <strong style="margin-left: 10px; margin-top: 5px">{{ $t("global.loading")}}</strong>
      </div>
    </div>
  </div>
</template>

<script>
    import TableFilterPopup from "@/components/ui/TableFilterPopup";
    import Vue from 'vue';
    import draggable from 'vuedraggable'

    Vue.directive('sortable', {
        inserted: function (el, binding) {
            if(binding.value.activate)
            {
                new Sortable(el, binding.value.options || {})
            }

        }
    })


    export default {
        name: 'table-component',
        components: {
            TableFilterPopup,
            draggable
        },
        props: {
            loading: Boolean,
            tableColumns: {
                type: Object,
                required: true
            },
            tableData: {
                type: Array,
                required: true
            },
            options: {
                type: Object,
                default: function(){
                    return {
                        disabled: true
                    }
                }
            }
        },
        data: () => ({
            nbPages: 7,
            currentPage: 1,
            tableDefs: function(){
                return this.tableColumns;
            },
            knownEvents: [
                'expired',
                'qrcode',
                'cancel',
                'send',
                'sendfirsttime',
                'onSelectAll',
                'onSelectRow',
                'associate'
            ]

        }),
        directives: {
            DynamicEvents: {
                bind: function (el, binding, vnode) {
                    const allEvents = binding.value;
                    allEvents.forEach((event) => {
                        // register handler in the dynamic component
                        vnode.componentInstance.$on(event, (eventData) => {
                            // when the event is fired, the proxyEvent function is going to be called
                            vnode.context.proxyEvent(event, eventData);
                        });
                    });
                },
                unbind: function (el, binding, vnode) {
                    vnode.componentInstance.$off();
                },
            },
        },
        computed: {
            nbColumns: function(){
                var nbColumns = 0;
                if(this.tableDefs.rowActions != null && this.tableDefs.rowActions.actions != null && this.tableDefs.rowActions.actions.length > 0)
                    nbColumns++;

                nbColumns += this.tableDefs.columns.length;

                return nbColumns;
            },
            tableDataObject: {
                get: function () {
                    return this.tableData;
                },
                set: function (val) {
                    this.tableData = val
                }
            }
        },
        methods: {
            displayIcon: function(type, column) {
              if(column == 'type') {
                if(type == 'Notification') {
                  return 'exclamation-triangle'
                }
                if(type == 'Planning') {
                  return 'calendar'
                }
              } else {
                return null
              }
            },
            createReceiversList: function(list, column) {
              if(column.key == "nb_datis") {
                if(list == undefined) {
                  return 'Liste des destinataires indisponible';
                } else {
                  if(list.length > 10) {
                    var limitedList =list.slice(0, 10)
                    return limitedList.join('\n') + '\net ' + (list.length-10) + ' autres'
                  }
                  return list.join('\n');
                }
              } else {
                return null
              }
            },
            handleEnd: function (evt) {
                this.$emit('endDrag', evt);
            },
            getSpRowClassname: function(item){
                if(item.spRowClassname != null){
                    var className = item.spRowClassname;
                    var result = item.spRowClassname.match(/{\s*[\w\.]+\s*}/g);
                    if(item.spRowClassname.match(/{\s*[\w\.]+\s*}/g)){
                        for(var i = 0; i<result.length; i++){
                            var key = result[i].replace('{','').replace('}','')
                            className = className.replace(result[i],item[key]);
                        }
                        return className;
                    }
                    else{
                        return item.spRowClassname;
                    }

                }
                return '';
            },
            handleRendererComponent:function(renderer){
                if(typeof renderer === 'object'){
                    return true;
                }
                return false
            },
            handleRendererFunction:function(renderer){
                if(typeof renderer === 'function'){
                    return true;
                }
                return false
            },
            popupHandler: function(column){
                column.showPopup = !column.showPopup;
            },
            handleSort: function(column,sort){
                this.unactivateSort();
                column.activeSort = sort;
                this.$emit('sort');
            },
            handleFilter: function(column,filter){
                //this.unactivateSortAndFilter();
                column.activeFilter = filter;
                this.$emit('filter');
            },
            unactivateSortAndFilter: function(){

                for(var cKey in this.tableColumns.columns){
                    var col = this.tableColumns.columns[cKey];
                    col.activeSort = false;
                    col.activeFilter = false;
                }
            },
            unactivateSort: function(){

                for(var cKey in this.tableColumns.columns){
                    var col = this.tableColumns.columns[cKey];
                    col.activeSort = false;
                }
            },
            parseLink: function(linkToParse, data){
                if(linkToParse == null)
                    return "";

                var link = linkToParse;

                for(var column in data){
                    link = link.replace(':'+column,data[column]);
                }

                return link;
            },
            onClickCell(column,item){
                if(column.event)
                {
                    this.$emit(column.event, item);
                }
            },
            onClickAction: function(action, item){
                if(action.event)
                {
                    this.$emit(action.event, item);
                }

            },
            accessValue: function(data,key){

                var _index = key.indexOf('.')
                if(_index > -1) {
                    return this.accessValue(data[key.substring(0, _index)], key.substr(_index + 1));
                }

                return data[key];
            },
            proxyEvent(eventName, eventData) {
                this.$emit(eventName,eventData);
            }
        },
        created: function(){
            this.tableDefs = this.tableColumns;
            this.tableDataObject = this.tableData;
            this.$nextTick(function(){
            })
        },
        mounted: function(){
            this.tableDefs = this.tableColumns;
            this.tableDataObject = this.tableData;
        },
        updated: function(){
            this.tableDefs = this.tableColumns;
            this.tableDataObject = this.tableData;
        }
    }
</script>

<style lang="scss">
.tableColumn-tooltip-wrapper{
  position: relative;
  display: inline-block;
}
</style>
